import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

//To Remove console logs when in production excluding warnings/errors
if(environment.production){
    window.console.log = () => {};
    window.console.debug = () => {};
}

bootstrapApplication(AppComponent, appConfig)
.catch((err) => console.error(err));